import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const images = [
  "/assets/images/shop/shop-thumb-01.png",
  "/assets/images/shop/shop-thumb-02.png",
  "/assets/images/shop/shop-thumb-03.png",
  "/assets/images/shop/shop-thumb-04.png",
  "/assets/images/shop/shop-thumb-05.png",
  "/assets/images/shop/shop-thumb-06.png",
  "/assets/images/shop/shop-thumb-07.png",
  "/assets/images/shop/shop-thumb-08.png",
  "/assets/images/shop/shop-thumb-09.png",
];

const Gallery = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <Wrapper>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">Gallery</h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>Gallery</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="rs-shop-area section-space">
        <div className="container">
          <div className="row g-4">
            {images.map((img, index) => (
              <div
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
                key={index}
              >
                <div className="gallery-wrapper">
                  <img src={img} alt="" className="gallery-img" />

                  {/* Button */}
                  <button
                    className="gallery-btn popup-image"
                    onClick={() => openModal(index)}
                  >
                    <i className="fas fa-plus" style={{ padding: "10px" }}></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {isOpen && (
        <div className="lightbox">
          <span className="close" onClick={closeModal}>
            &times;
          </span>

          <img src={images[currentIndex]} alt="" className="lightbox-img" />

          <button className="prev" onClick={prevSlide}>
            ❮
          </button>

          <button className="next" onClick={nextSlide}>
            ❯
          </button>
        </div>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .gallery-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }

  .gallery-img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    transition: 0.3s;
    border-radius: 10px;
  }

  /* Overlay */
  .gallery-wrapper::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    transition: 0.3s;
  }

  /* Button */
  .gallery-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.8);
    background: #ff6118;
    border: none;
    color: #fff;
    font-size: 20px;
    padding: 10px, 12px, 10px, 12px;
    border-radius: 50%;
    cursor: pointer;
    opacity: 0;
    transition: 0.3s;
    z-index: 2;
  }

  /* Hover Effects */
  .gallery-wrapper:hover::after {
    opacity: 1;
  }

  .gallery-wrapper:hover .gallery-btn {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  .gallery-wrapper:hover .gallery-img {
    transform: scale(1.05);
  }

  /* Lightbox */
  .lightbox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }

  .lightbox-img {
    max-width: 90%;
    max-height: 90%;
    border-radius: 10px;
  }

  .close {
    position: absolute;
    top: 20px;
    right: 40px;
    font-size: 40px;
    color: #fff;
    cursor: pointer;
  }

  .prev,
  .next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    background: none;
    border: none;
    cursor: pointer;
  }

  .prev {
    left: 30px;
  }

  .next {
    right: 30px;
  }
`;

export default Gallery;
